export default class ComponentPromoModal {
    constructor(container, options) {
        const defaultOptions = {
            closeBtn: '.close'
        };
        this.options = Object.assign({}, defaultOptions, options);

        this.container = document.querySelector(container);
        this.closeBtn = this.container.querySelectorAll(this.options.closeBtn);
        
        this.setEvents();
        this.onInit();
    }

    setEvents() {
        this.closeBtn.forEach(button => {
            button.addEventListener('click', e => {
                e.stopPropagation()
                this.container.style.display = 'none';
            })
        })
    }
    
    onInit() {
        var promoModalStorage = sessionStorage.getItem('promo');
        var dataTimeout = this.container.getAttribute('data-timeout');

        if (promoModalStorage !== 'teeg-modal-seen') {
            setTimeout(() => {
                this.container.style.display = 'block'
                sessionStorage.setItem('promo', 'teeg-modal-seen')
            }, `${dataTimeout}000`);
        }
    }
}